module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel202309_03_1280_1280_en-0e3ef7dd5add03f1d2addfd4243949ae.jpg";